import(/* webpackMode: "eager" */ "/Users/nik4o/Desktop/New Ver Web/iliqta/app/auth/forgot-password/page.tsx");
